import script from "./OutbrainIframeBanner320Slot1.vue?vue&type=script&setup=true&lang=js"
export * from "./OutbrainIframeBanner320Slot1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__